import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import classnames from "classnames/dedupe";

import { PdfPreviewModal } from "components/PdfPreview/PdfPreviewModal";
import { downloadOneFile } from "utils/file/download-file";
import { getNestedObjValue } from "../helpers";
import { GT } from "components/index";

import "./edit-file-input.styles.scss";

export const EditFileInput = (props) => {
    const [openPreviewModal, setOpenPreviewModal] = useState<boolean>(false);
    const {
        //base
        value = undefined,
        name = undefined,
        shouldDataSetRefresh: refresh = false,
        extraEditParams = {},
        editUrl = undefined,
        secondPartEditUrl = undefined,
        className = "",
        clientSideEdit = false,
        style = {},
        editParamsBeforeChange = undefined,
        extraParametersToSet = undefined,
        urlInstanceId,
        disableButtons = []
    } = props;

    const { row, fieldName, handleEditSubmit, permCode = "", rowIndex } = props.inputData;

    const content = value || getNestedObjValue(row, fieldName.split("."));
    const isInputEmpty = !content;

    const formatFileName = row?.fileName || content?.substr(content?.lastIndexOf("/") + 1);
    const isPdf = content?.toLowerCase()?.endsWith(".pdf");

    const { t } = useTranslation();

    const handleEdit = async (e) => {
        let formData: FormData | undefined = undefined;
        let value: undefined | null = undefined;
        const params = editParamsBeforeChange ? editParamsBeforeChange(extraEditParams, e.target.files) : extraEditParams;

        if (!!e.target.files) {
            formData = new FormData();
            console.log(e.target.files[0]);
            formData.append("file", e.target.files[0]);
        } else {
            value = null;
        }

        const response = await handleEditSubmit({
            row: row,
            e: { target: { name: fieldName, value, formData } },
            secondPartEditUrl: secondPartEditUrl,
            extraColumnEditParams: params,
            refresh: refresh,
            clientSideEdit: clientSideEdit,
            extraParametersToSet: extraParametersToSet,
            editUrl,
            urlInstanceId,
            reqParams: { permCode },
        });
        return response;
    };

    const handleVisibleOnCp = async () => {
        const response = await handleEditSubmit({
            row: row,
            e: { target: { name: "isVisibleOnCp", value: !row.isVisibleOnCp } },
            secondPartEditUrl: secondPartEditUrl,
            extraColumnEditParams: undefined,
            refresh: refresh,
            clientSideEdit: clientSideEdit,
            extraParametersToSet: extraParametersToSet,
            editUrl,
            urlInstanceId,
            reqParams: { permCode },
        });
        return response;
    };

    return (
        <div
            className={classnames("file-table-edit", className)}
            style={style}
            id={`prime-input-file-${fieldName}-${rowIndex}`}
            key={`prime-input-file-${fieldName}-${row.id}`}
            onKeyDown={(e) => e.stopPropagation()}
        >
            {isInputEmpty && (
                <>
                    <input id="file-input" hidden type="file" multiple={false} onChange={handleEdit} />
                    <label htmlFor="file-input" className="edit-file-input">
                        {t("Choose a file")}
                    </label>
                </>
            )}

            {!isInputEmpty && (
                <>
                    <GT.TooltipHOC tooltipContent={formatFileName} className="file-name">
                        {formatFileName}
                    </GT.TooltipHOC>
                    <div>
                        {row.isVisibleOnCp !== undefined && (
                            <GT.Button
                                text="CP"
                                style={{ color: "white", textDecoration: row.isVisibleOnCp ? "line-through" : "none" }}
                                tooltipContent={row.isVisibleOnCp ? "Remove from CP" : "Attach to CP"}
                                withoutPerm
                                onClick={handleVisibleOnCp}
                                disabled={disableButtons.includes('sentToCp')}
                            ></GT.Button>
                        )}
                        <GT.Button
                            withoutPerm
                            tooltipContent="Download"
                            icon={{ name: ["fas", "download"] }}
                            onClick={() => downloadOneFile(content, formatFileName)}
                            disabled={disableButtons.includes('download')}
                        ></GT.Button>
                        {isPdf && (
                            <GT.Button
                                withoutPerm
                                tooltipContent="Preview"
                                icon={{ name: ["fas", "eye"] }}
                                onClick={() => setOpenPreviewModal((prevState) => !prevState)}
                                disabled={disableButtons.includes('preview')}
                            ></GT.Button>
                        )}
                        <GT.Button
                            tooltipContent="Delete"
                            withoutPerm
                            icon={{ name: ["fas", "trash"] }}
                            onClick={handleEdit}
                            disabled={disableButtons.includes('delete')}
                        >
                        </GT.Button>
                        {openPreviewModal && (
                            <PdfPreviewModal
                                closeModal={() => setOpenPreviewModal(false)}
                                file={{ file: content, fileName: formatFileName }}
                            />
                        )}
                    </div>
                </>
            )}
        </div>
    );
};
